import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { LoginForm } from './Auth/LoginForm'

const isLocalDev = () => {
  const h = window.location.hostname
  return h === 'localhost' || h === '127.0.0.1'
}

export const RootRedirect: React.FC = () => {
  const { user, loading } = useAuth()

  useEffect(() => {
    // Only redirect to marketing site on the real production host
    if (!loading && !user && !isLocalDev()) {
      window.location.href = 'https://syncsimple.ai/'
    }
  }, [user, loading])

  // Show loading while authentication is being checked
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          <p className="mt-2 text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // If user is authenticated, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />
  }

  // On localhost show the login form instead of redirecting to the marketing site
  if (isLocalDev()) {
    return <LoginForm />
  }

  // Production: useEffect above will fire the redirect; render nothing while it runs
  return null
}
